import { saveStates, states } from '@/constants/lifecycle';
import withDraft from '@/utils/draftHelper';
import { responseError } from '@/utils/errors';
import { assignProps } from '@/utils/resultsHelper';
import actions from '../constants';
import { findDataModels, findDatasetDataModel } from './state';

const fetchDataModels = withDraft((draft, action) => {
  const item = findDataModels(draft, action);
  item.readErrors = [];
  item.results = [];
  item.readStatus = states.PENDING;
});

const fetchDataModelsError = withDraft((draft, action) => {
  const item = findDataModels(draft, action);
  item.readErrors = [responseError(action)];
  item.results = [];
  item.readStatus = states.ERROR;
});

const fetchDataModelsSuccess = withDraft((draft, action) => {
  const item = findDataModels(draft, action);
  item.readErrors = [];
  item.results = action.result;
  item.readStatus = states.SUCCESS;
});

const fetchDatasetDataModel = withDraft((draft, { category, code }) => {
  const item = findDatasetDataModel(draft, { category, code });

  if (item) {
    item.readStatus = states.PENDING;
    item.readErrors = [];
  } else {
    draft.dataModels[category].results.push({ code, readErrors: [], readStatus: states.PENDING });
  }
});

const fetchDatasetDataModelError = withDraft((draft, action) => {
  const item = findDatasetDataModel(draft, action);
  item.readStatus = states.ERROR;
  item.readErrors = [responseError(action)];
});

const fetchDatasetDataModelSuccess = withDraft((draft, { category, code, result }) => {
  const item = findDatasetDataModel(draft, { category, code });

  const props = {
    dataModelCode: result.code,
    readErrors: [],
    readStatus: states.SUCCESS,
    ...saveStates,
  };

  if (item) {
    assignProps(item, props);
  } else {
    draft.dataModels[category].results.push({ code, ...props });
  }
});

const updateDatasetDataModel = withDraft((draft, { category, code }) => {
  const item = findDatasetDataModel(draft, { category, code });

  if (item) {
    item.saveStatus = states.PENDING;
    item.saveErrors = [];
  } else {
    draft.dataModels[category].results.push({ code, saveErrors: [], saveStatus: states.PENDING });
  }
});

const updateDatasetDataModelError = withDraft((draft, action) => {
  const item = findDatasetDataModel(draft, action);
  item.saveStatus = states.ERROR;
  item.saveErrors = [responseError(action)];
});

const updateDatasetDataModelSuccess = withDraft((draft, { category, code, result }) => {
  const item = findDatasetDataModel(draft, { category, code });
  const props = { dataModelCode: result.code, saveErrors: [], saveStatus: states.SUCCESS };
  assignProps(item, props);
});

export default {
  [actions.FETCH_DATA_MODELS]: fetchDataModels,
  [actions.FETCH_DATA_MODELS_ERROR]: fetchDataModelsError,
  [actions.FETCH_DATA_MODELS_SUCCESS]: fetchDataModelsSuccess,
  [actions.FETCH_DATASET_DATA_MODEL]: fetchDatasetDataModel,
  [actions.FETCH_DATASET_DATA_MODEL_ERROR]: fetchDatasetDataModelError,
  [actions.FETCH_DATASET_DATA_MODEL_SUCCESS]: fetchDatasetDataModelSuccess,
  [actions.UPDATE_DATASET_DATA_MODEL]: updateDatasetDataModel,
  [actions.UPDATE_DATASET_DATA_MODEL_ERROR]: updateDatasetDataModelError,
  [actions.UPDATE_DATASET_DATA_MODEL_SUCCESS]: updateDatasetDataModelSuccess,
};
